@if (loader.isLoading$ | async) {
   <div class="spinner-overlay">
      <mat-spinner role="progressbar" attr.aria-label="{{ 'loader.aria.spinner' | translate }}"></mat-spinner>
   </div>
}
